import NewMeeting from './NewMeeting'
import {Nullable} from '../../../app/TypeHelpers'
import {MeetingLink} from './MeetingLink'

export default class UpdateMeeting extends NewMeeting {
    attendanceReplyRequestDatetime: Nullable<string>
    meetingAnnounceNotifyDatetime: Nullable<string>
    deleteMeetingFileNumberList: number[]
    deleteReportNumberList: number[]
    version: Nullable<number>

    constructor(
        name: string,
        date: Nullable<string>,
        startTime: Nullable<string>,
        endTime: Nullable<string>,
        url: Nullable<string>,
        place: Nullable<string>,
        memo: Nullable<string>,
        contents: Nullable<string>,
        attendanceReplyDeadline: Nullable<string>,
        attendanceReplyRequestDatetime: Nullable<string>,
        manageAttendance: string,
        proxyAttendanceAvailability: Nullable<string>,
        meetingAnnounceNotifyDatetime: Nullable<string>,
        meetingAttachmentLinkList: MeetingLink[],
        deleteMeetingFileNumberList: number[],
        deleteReportNumberList: number[],
        version: Nullable<number>) {
        super(
            name,
            date,
            startTime,
            endTime,
            url,
            place,
            memo,
            contents,
            attendanceReplyDeadline,
            manageAttendance,
            proxyAttendanceAvailability,
            meetingAttachmentLinkList,
        )
        this.attendanceReplyRequestDatetime = attendanceReplyRequestDatetime
        this.meetingAnnounceNotifyDatetime = meetingAnnounceNotifyDatetime
        this.deleteMeetingFileNumberList = deleteMeetingFileNumberList
        this.deleteReportNumberList = deleteReportNumberList
        this.version = version
    }
}
